import { FieldHasValue } from 'helpers/Validation';

export const ReCalibrationNeededS81 = (formData) => {
    if (FieldHasValue(formData.F102AftResult)) {
        if (formData.F102AftResult === 'PASS') {
            return 'NO';
        }
        return 'YES';
    }
    return '';
};
